import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getDashboard = () => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getDashboard().then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETDASHBOARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETDASHBOARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETDASHBOARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getLogs = () => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.getLogs().then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETLOGSSUCCESS,
                payload: JSON.parse(res).data,
            });
            // dispatch({
            //     type: ActionTypes.LOADING,
            //     payload: false,
            // });
        }
        else {
            // alert(JSON.parse(res).title);
            // dispatch({
            //     type: ActionTypes.LOADING,
            //     payload: false,
            // });
            dispatch({
                type: ActionTypes.GETLOGSFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETLOGSFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleLogs = (value) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleLogs(value).then(res => {
        
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLELOGSSUCCESS,
                payload: JSON.parse(res).data,
            });
            // dispatch({
            //     type: ActionTypes.LOADING,
            //     payload: false,
            // });
            Toast.fire({
                icon: 'success',
                title: 'Logs Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            // dispatch({
            //     type: ActionTypes.LOADING,
            //     payload: false,
            // });
            dispatch({
                type: ActionTypes.TOGGLELOGSFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.TOGGLELOGSFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}